import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { ResenjeZaGo } from './resenje-za-go';

@Component({
  selector: 'yt-resenje-za-go-tab-update',
  templateUrl: './resenje-za-go-tab-update.component.html'
})
export class ResenjeZaGoTabUpdateComponent 
extends BaseTabsUpdateComponent<ResenjeZaGo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<ResenjeZaGo>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
